export default __webpack_public_path__ + "static/media/logo-without-modules.fb38191b.png";